<template>
  <div class="platformConfig">
    <Breadtabsheader/>
    <div class="h-piece h-mrt30" style="margin:20px">
      <div class="h-formBox">
        <el-form :inline="true" ref="ruleForm" :model="ruleForm" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="平台商A">
              <el-input v-model="ruleForm.ptNameA" placeholder="请输入平台商A" clearable></el-input>
            </el-form-item>
            <el-form-item label="代理商">
              <el-input v-model="ruleForm.agentName" placeholder="请输入代理商" clearable></el-input>
            </el-form-item>
            <el-form-item label="模式">
              <el-select v-model="ruleForm.type" placeholder="请选择" clearable>
                <el-option label="模式一" value="1"></el-option>
                <el-option label="模式二" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="ruleForm.delflag" placeholder="请选择" clearable>
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="平台商B">
                  <el-input v-model="ruleForm.ptNameB" placeholder="请输入平台商B" clearable></el-input>
                </el-form-item>
              </div>
              <el-form-item label="销售公司" required class="h-elformWrap-2">
                <brselect placeholder="请选择"
                          category="xsyb_gongsi"
                          :v="ruleForm.gscode"
                          clearable
                          v-model="ruleForm.gscode">
                </brselect>
              </el-form-item>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn" @click="handleAdd">新增</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30" style="margin:20px">
      <el-table ref="multipleTable" :data="tableData"
                stripe style="width: 100%"  :border="true" :row-style="cellstyle" max-height="460">
        <el-table-column prop="gscode" label="销售公司" min-width="160" :show-overflow-tooltip="true" fixed></el-table-column>
        <el-table-column prop="ptNameA" label="平台商A" min-width="180" :show-overflow-tooltip="true" fixed>
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.ptNameA}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ptNameB" label="平台商B" min-width="180" :show-overflow-tooltip="true" fixed>
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.ptNameB}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="代理商名称" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column
                prop="type"
                :show-overflow-tooltip="true"
                width="100"
                label="模式">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.type == 1">模式一</span>
              <span v-if="scope.row.type == 2">模式二</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
                prop="type"
                :show-overflow-tooltip="true"
                width="100"
                label="状态">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.delflag == 1">正常</span>
              <span v-if="scope.row.delflag == 0">禁用</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="创建人" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column fixed="right" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button
                size="small" class="h-tableLink h-btn"
                @click="handleEdit(scope.row)">修改
            </el-button>
            <el-button v-show="scope.row.delflag == 1"
                       size="small" class="h-tableLink h-btn"
                       @click="delOrRes(scope.row.id,0)">禁用
            </el-button>
            <el-button
                    v-show="scope.row.delflag == 0"
                    size="small" class="h-tableLink h-btn"
                    @click="delOrRes(scope.row.id,1)">恢复
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL" style="margin-left:20px">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" style="margin-left:-20px;" @click="exportExcel">
            批量导出
          </el-button>

          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                     @click="uploaddownexcelflagbtn">批量导入
          </el-button>
          <uploaddownexcel
                  :visible.sync="uploaddownexcelflag"
                  v-if="uploaddownexcelflag"
                  clsname="bscHhptAgentTypeExcel"
                  :startrow="2"
                  :extparams="ruleForm"
                  @callback="uploadExcelFilecallback"/>

        </div>
        <div class="h-pagination2">
          <pagination :page="ruleForm" @query="query" />
        </div>
      </div>
    </div>

    <!--新建或修改-->
    <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{dialogTitle}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLine">
          <el-form :model="order" ref="add" label-position="right" :inline="true"
                   label-width="80" :rules="editFormRules"
                   class="demo-ruleForm h-formbLine h-formbLine1">
            <el-form-item label="销售模式" prop="type">
              <el-select v-model="order.type" filterable clearable @change="handlechangeType"
                         placeholder="请选择销售模式" style="width: 100%;">
                <el-option
                    v-for="item in orderTypeList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="销售公司" prop="gscode">
              <brselect category="xsyb_gongsi" :v="order.gscode" @change="handleSale($event)" style="width: 100%;"
                        v-model="order.gscode"/>
            </el-form-item>

            <el-form-item label="代理商" prop="agentName">
              <el-select v-model="order.agentName" remote filterable :filter-method="showGroupList" clearable @change="handleItemChange($event)"
                         placeholder="请选择代理商" style="width: 100%;">
                <el-option
                    v-for="item in agList"
                    :key="item.usercode"
                    :label="item.username+'-'+item.usercode"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台商A1" v-if="order.type == '1'" prop="ptNameA">
              <el-select v-model="order.ptNameA" filterable clearable :filter-method="showGroupListA" @change="handleChangeA"
                         placeholder="请选择平台商A1" style="width: 100%;">
                <el-option
                        v-for="item in ptaList"
                        :key="item.usercode"
                        :label="item.username+'-'+item.usercode"
                        :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台商B1" v-if="order.type == '1'" prop="ptNameB">
              <el-select v-model="order.ptNameB" filterable clearable :filter-method="showGroupListB" @change="handleChangeB"
                         placeholder="平台商B1" style="width: 100%;">
                <el-option
                        v-for="item in ptbList"
                        :key="item.usercode"
                        :label="item.username+'-'+item.usercode"
                        :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取 消</el-button>
          <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleSave('add')" v-if="!disEdit">确 定</el-button>
          <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleUpdate('add')" v-if="disEdit">修 改</el-button>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import uploaddownexcel from "../../../components/uploaddown/uploaddownexcel";

export default {
  components: {
    uploaddownexcel,
  },
  data(){
    return{
      ruleForm:{
        type: '',
        agentName: '',
        gscode: '',
        gsname: '',
        ptNameA: '',
        ptNameB: '',
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      tableData: [
        {index:1}
      ],
      isScreen: false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      showDialog: false,//新增
      dialogTitle: '新增平台商配置',
      order:{
        type: '',
        gscode: '',
        agentName: '',
        agentCode: '',
        ptCodeA: '',
        ptNameA: '',
        ptCodeB: '',
        ptNameB: '',
      },
      editFormRules: {
        type:[{required: true, message: '请选择销售模式', trigger: 'change'}],
        gscode:[{required: true, message: '请选择销售公司', trigger: 'change'}],
        agentName:[{required: true, message: '请选择代理商', trigger: 'change'}],
        ptNameA:[{required: true, message: '请选择平台商A', trigger: 'change'}],
      },
      disEdit: false,//是否修改
      //导入Excel
      uploaddownexcelflag: false,
      orderTypeList: [
        {
          code: 1,
          name: '模式一'
        },
        {
          code: 2,
          name: '模式二'
        }
      ],
      agList:[],
      ptaList:[],
      ptbList:[],
    }
  },
  methods:{
    cellstyle(value){
      if(value.row.isClose == '0' && value.row.type == '3'){
        return 'color: #F56C6C;'
      }
    },
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    //检索
    handleFilter(){
      this.query();
    },
    //重置
    resetData(){
      this.$refs['ruleForm'].resetFields();
    },
    //导出
    exportExcel(){

    },
    query() {
      ss.bscHhptAgentType.selectPage(this.ruleForm).then(rd => {
        this.ruleForm.total = rd.total;
        this.tableData = rd.records;
      })
    },
    //导入Excel
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },
    // 新增
    handleAdd(){
      this.dialogTitle = '新增平台商配置'
      this.showDialog = true
      this.disEdit = false
    },
    //选择销售模式
    handleOrderChange(){

    },
    //返回
    cancel(){
      this.showDialog = false
      this.order = {}
      this.$refs.add.resetFields();
      this.disEdit = false
    },
    //销售模式选择事件
    handlechangeType(){
      console.log(this.order.type)
    },
    //代理商输入查询事件
    showGroupList(value){
      ss.bscHhptAgentType.getAgent(value).then(rd => {
        this.agList = rd;
      })
      //调用方法
    },
    //代理商输入查询事件
    showGroupListA(value){
      ss.bscHhptAgentType.getAgent(value).then(rd => {
        this.ptaList = rd;
      })
      //调用方法
    },
    //代理商输入查询事件
    showGroupListB(value){
      ss.bscHhptAgentType.getAgent(value).then(rd => {
        this.ptbList = rd;
      })
      //调用方法
    },
    //销售公司选择事件
    handleSale(value){
      console.log(value)
    },
    handleItemChange(value){
      this.order.agentCode = value.usercode
      this.order.agentName = value.username
    },
    handleChangeA(value){
      this.order.ptCodeA = value.usercode
      this.order.ptNameA = value.username
    },
    handleChangeB(value){
      this.order.ptCodeB = value.usercode
      this.order.ptNameB = value.username
    },
    //修改
    handleEdit(row){
      console.log(row)
      this.dialogTitle = '修改平台商配置'
      this.showDialog = true
      this.disEdit = true
      this.order = row
    },

    delOrRes(id,del){
      let value = {
        id: id,
        delflag: del
      }
      ss.bscHhptAgentType.delOrRes(value).then(rd => {
        this.query();
      })
    },
    //提交事件
    handleSave(){
      ss.bscHhptAgentType.saveOrUpdate(this.order).then(rd => {
        this.ptbList = rd;
      })
      this.showDialog = false
      this.disEdit = false
    },
    //确定修改事件
    handleUpdate(){
      ss.bscHhptAgentType.saveOrUpdate(this.order).then(rd => {
        this.ptbList = rd;
      })
      this.showDialog = false
      this.disEdit = false
    }
  },

  created() {
    this.query();
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}
/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
.demo-ruleForm{
  margin-top: 20px;
}
</style>